import axiosClient from "api/axios-client";

export const GetCustomerPortfolio = async()=>{
    const response = await axiosClient.get('/ifincredit/dashboard/customerPortfolio');
    //console.log(response)
    return response;
}